<template lang="pug">
  div
    doc-markdown(source=`
    ## Profiling Boolean \`profiling-boolean\`
    Intermediary wrapper between our profiling Sections and the \`profiling-radio\` UI component, in a handy version that can be easily used for boolean questions.
    `)

    doc-preview(vue=`
    .mb-3 Is Seraphin back-end coded in PHP ?
    profiling-boolean(
      v-model="answer"
      :error="error"
      custom-classes="w-1/4"
      data-purpose-prop="is_backend_php"
    )
    .cursor-pointer.text-blue-500(@click="displayError = !displayError") Show errors

    <script>
        ...
        data () {
          return {
            answer: '',
            displayError: false,
          };
        },
        computed: {
          error () { return this.displayError && !!this.answer; },
        },
      };
    </script>
    `)
      .mb-3 Is Seraphin back-end coded in PHP ?
      profiling-boolean(
        v-model="answer"
        :error="error"
        custom-classes="w-1/4"
        data-purpose-prop="is_backend_php"
      )
      .cursor-pointer.text-blue-500(@click="displayError = !displayError") Show errors

    doc-markdown(source=`
    ### Properties
  | Props                | Description                                                          | Type                    | Default |
  |----------------------|----------------------------------------------------------------------|-------------------------|---------|
  | \`value\` (v-model)  | Chosen value to which the boolean radios are binded.	                | String, Boolean, Number | -       |
  | \`custom-classes\`   | Custom classes that can be passed to underlying \`profiling-radio\`. | String                  | -       |
  | \`data-purpose-prop\`| Data-purpose attribute.                                              | String                  | -       |
  | \`error\`            | Whether the red error highlighting should be displayed or not.       | Boolean                 | -       |
  | \`reverse\`          | To indicate if the \`true\` and \`false\` value encapsulated in the underlying component should be reversed.<br \>Useful if you want the 'No' to appear before the 'Yes'.  | Boolean | false    |
    `)

    doc-markdown(source=`
    ### Events
  | Event name | Description                            | Parameters             | Usage      |
  |------------|----------------------------------------|:----------------------:|------------|
  | input      | Triggered when boolean value chosen.   | Chosen boolean value.  | \`@input\` |
    `)
</template>

<script>
  export default {
    data () {
      return {
        answer: '',
        displayError: false,
      };
    },
    computed: {
      error () { return this.displayError && !!this.answer; },
    },
  };
</script>
